import { useState } from 'react';

import { Slide } from 'react-awesome-reveal';

import { useApp } from '../app-context';
import { ChatService } from '../services/ChatService'
import { DatePicker } from '../components/DatePicker';

import './ChooseDatePage.scss';

const ChooseDatePage = function ({ onBack, btn }) {
    const [state, dispatcher] = useApp();

    const [stateBusy, setStateBusy] = useState(false);

    const handleBack = (e) => {
        if (stateBusy) return;

        if (onBack)
            onBack(true, e);
    };

    const handleSubmit = (dateYYYYMMDD) => {
        if (stateBusy) return;

        if (!dateYYYYMMDD) return;

        setStateBusy(true);

        let answer = {
            display: dateYYYYMMDD.substring(6, 8) + "/" + dateYYYYMMDD.substring(4, 6) + "/" + dateYYYYMMDD.substring(0, 4),
            value: dateYYYYMMDD,
            id: btn?.id,
            field: btn?.field
        }

        ChatService.processAnswer(dispatcher, state, answer)
            .then(() => {
                dispatcher({ action: 'closeOverlay', params: 'chooseDate' });
            })
            .catch(ex => {
                //TODO: todo
                alert(ex);
            }).finally(() => {
                setStateBusy(false);
            });
    };

    return (
        <div className="popupPage chooseDatePage">
            <Slide direction="up" duration="500">
                <div className="container on" style={{display: stateBusy ? "none": ""}}>
                    <DatePicker onDateSelected={handleSubmit} onCancel={handleBack} allowFuture={false} />
                </div>
            </Slide >
        </div >
    );
}

export { ChooseDatePage }
